import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=5ede7ef2&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports